import { asyncRoutes, constantRoutes } from "@/router";

// /**
//  * Use meta.role to determine if the current user has permission
//  * @param roles
//  * @param route
//  */
// function hasPermission(roles, route) {
//   if (route.meta && route.meta.roles) {
//     return roles.some(role => route.meta.roles.includes(role));
//   } else {
//     return true;
//   }
// }
//
// /**
//  * Filter asynchronous routing tables by recursion
//  * @param routes asyncRoutes
//  * @param roles
//  */
// export function filterAsyncRoutes(routes, roles) {
//   const res = [];
//
//   routes.forEach(route => {
//     //...深拷贝
//     const tmp = { ...route };
//     if (hasPermission(roles, tmp)) {
//       if (tmp.children) {
//         tmp.children = filterAsyncRoutes(tmp.children, roles);
//       }
//       res.push(tmp);
//     }
//   });
//   return res;
// }

const state = {
  routes: []
  // addRoutes: []
};

const mutations = {
  SET_ROUTES: (state, routes) => {
    // state.addRoutes = routes
    state.routes = constantRoutes.concat(routes);
  }
};

const actions = {
  generateRoutes({ commit }, roles) {
    return new Promise(resolve => {
      let accessedRoutes;
      if (roles.includes("1")) {
        accessedRoutes = asyncRoutes || [];
      } else {
        // accessedRoutes = filterAsyncRoutes(asyncRoutes, roles);
        accessedRoutes = asyncRoutes.filter(item => {
          item.children = filterAsyncRoutes(item.children, roles);
          if (item.children && item.children.length > 0) {
            return true;
          } else {
            return false;
          }
        });
      }
      accessedRoutes.push({ path: "*", redirect: "/404", hidden: true });
      commit("SET_ROUTES", accessedRoutes);
      resolve(accessedRoutes);
    });
  }
};

function filterAsyncRoutesPermission(permissions, permissions1) {
  const accessedRouters = permissions.filter(route => {
    let permissions = route.permissions;
    const hasPermission = permissions1.some(permission => {
      return route.includes(permission);
    });
    if (!hasPermission) {
      return false;
    }
    return true;
  });
  return accessedRouters;
}
function filterAsyncRoutes(asyncRouterMap, permissions1) {
  const accessedRouters = asyncRouterMap.filter(route => {
    if (
      (!route.permissions || route.permissions.length === 0) &&
      route.hidden
    ) {
      return false;
    }
    if (!route.hidden && route.permissions.length === 0) {
      return true;
    }
    let permissions = filterAsyncRoutesPermission(
      route.permissions,
      permissions1
    );
    if (permissions.length > 0) {
      return true;
    }
    return false;
  });
  return accessedRouters;
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/permission.js